import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { ModalHeader, ModalContents, ModalFooter } from '../../../common/modal'

import { withStyles } from 'material-ui/styles'
import styles from './styles'


class UploadManufacturer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      modal : false
    }
    this.state = {
      cableinfofile : null,
      connectorinfofile : null,
      errors:{

      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.uploadManufactuerDbFile = this.uploadManufactuerDbFile.bind(this)
  }
  handleChange(e) {
    let errors = {...this.state.errors}
    if(e.target.type=='file' && e.target.files.length){
      let fileExtention = e.target.files[0].name.split('.').pop();
      if(fileExtention === 'json'){
        this.setState({
          [e.target.name] : e.target.files[0],
          errors : {
            ...errors,
            [e.target.name] : false
          }
        })
      }else{
        this.setState({
          errors : {
            ...errors,
            [e.target.name] : true
          }
        })
      }
    }
  }
  uploadManufactuerDbFile(e) {
    e.preventDefault()
    let cablefile = this.state.cableinfofile
    let connectorfile = this.state.connectorinfofile
    var fd = new FormData();
    if(cablefile || connectorfile){
      if(cablefile){
        fd.append('manufacturerfiles', cablefile)
        fd.append('cable',cablefile.name)
      }
      if(connectorfile){
        fd.append('manufacturerfiles', connectorfile)
        fd.append('connector',connectorfile.name)
      }
      this.props.uploadManufacturerDb(fd)
      this.props.onClose()
    }

  }
  render(){
    const { classes, translate, onClose } = this.props
    const { cableinfofile, connectorinfofile, errors} = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_manufacturerdb_title")}
              </Typography>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.cableinfofile ? true : false}
                  >
                  <InputLabel htmlFor="cableinfofile" shrink={true} disableAnimation={true}>{translate("settings_cableinfofile_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="cableinfofile"
                      type="file"
                      name="cableinfofile"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"cableinfofile"
                      }}
                  />
                  <FormHelperText id="cableinfofile-helper-text">{translate("settings_cableinfofile_help")}</FormHelperText>
                </FormControl>
                <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.connectorinfofile ? true : false}
                  >
                  <InputLabel htmlFor="connectorinfofile" shrink={true} disableAnimation={true}>{translate("settings_connectorinfofile_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="connectorinfofile"
                      type="file"
                      name="connectorinfofile"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"connectorinfofile"
                      }}
                  />
                  <FormHelperText id="connectorinfofile-helper-text">{translate("settings_connectorinfofile_help")}</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>
            <ModalFooter>
              <Button raised
                onClick={onClose}
              >
                {translate('general_cancel')}
              </Button>
              {(cableinfofile || connectorinfofile) ? (<Button raised
                color="accent"
                type="submit"
                onClick={this.uploadManufactuerDbFile}
              >
                {translate("settings_upload")}
              </Button>) : null}

            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(UploadManufacturer)
